// Products.js
import React, { useEffect, useState } from "react";
import { Box, Button, useTheme, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "components/Header";
import Popup from "components/Popup";
import {
  CancelPresentationSharp,
  CheckBox,
  DeleteOutline,
  ListAltOutlined,
} from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";
import { server } from "server";
import { Link } from "react-router-dom";
import "./product.css";
import PopupConfirm from "components/PopupConfirm";
import FlexBetween from "components/FlexBetween";
import FormProduct from "scenes/form";
import DataGridProductToolBar from "components/DataGridProductToolBar";

const Products = () => {
  const theme = useTheme();

  const [openPopup, setOpenPopup] = useState(false);
  const [product, setProduct] = useState([]);
  const [userId, setUserId] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    axios.get(`${server}/product/get-all-products`).then((res) => {
      setProduct(res.data.allproducts);
    });
  }, []);

  const handleDelete = (id) => {
    axios
      .delete(`${server}/product/delete-product/${id}`)
      .then((res) => {
        toast.success(res.data.message);
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const formatNumber = (number) => {
    return number.toLocaleString();
  };

  const columns = [
    {
      field: "createdAt",
      headerName: "Creé le",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Article",
      flex: 1,
    },
    {
      field: "desc",
      headerName: "Description",
      flex: 1,
    },
    {
      field: "stock",
      headerName: "Quantité en Stock",
      flex: 1,
    },
    {
      field: "price_achat",
      headerName: "Prix d'achat (Fbu)",
      flex: 1,
    },
    {
      field: "userName",
      headerName: "Fait par",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      width: 115,
      renderCell: (params) => {
        return (
          <>
            <Link to={"/productEdit/" + params.row.id}>
              <button className="userListEdit">Edit</button>
            </Link>
            <DeleteOutline
              className="userListDelete"
              onClick={() =>
                setUserId(params.row.id) || setOpenDelete(!openDelete)
              }
            />
          </>
        );
      },
    },
    {
      field: "Ajouter",
      headerName: "Ajouter le stock",
      flex: 1,
      renderCell: (params) => {
        return (
          <Link to={"/ProductPriceEdit/" + params.row.id}>
            <button className="userListEdit">Ajouter</button>
          </Link>
        );
      },
    },
  ];

  const filteredProducts = product.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const row = [];

  filteredProducts.forEach((item) => {
    row.push({
      id: item._id,
      name: item.name,
      desc: item.desc,
      price_achat: formatNumber(item.price_achat),
      stock: item.stock,
      total: formatNumber(item.total),
      userName: item.userName,
      createdAt: item.createdAt.slice(0, 10),
    });
  });

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="Produits" subtitle="Liste des Produits" />
      <br />
      <Link to="/pendingproduct">
        <Button
          color="secondary"
          variant="contained"
          style={{ marginBottom: "6px" }}
        >
          <ListAltOutlined />
          Les Produits en attente
        </Button>
      </Link>
      <br />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <TextField
          variant="outlined"
          placeholder="Rechercher un produit"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ width: "300px" }}
        />
      </Box>
      <Box
        height="80vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <DataGrid
          rows={row}
          columns={columns}
          components={{ Toolbar: DataGridProductToolBar }}
          componentsProps={{
            toolbar: { openPopup, setOpenPopup },
          }}
        />
      </Box>
      <Popup
        title="Product from"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <FormProduct setOpenPopup={setOpenPopup} />
      </Popup>
      <PopupConfirm
        title="Voulez-vous supprimer le produit "
        open={openDelete}
        setOpen={setOpenDelete}
      >
        <FlexBetween>
          <Button
            color="secondary"
            variant="contained"
            style={{ marginBottom: "1px" }}
            onClick={() => setOpenDelete(!openDelete) || handleDelete(userId)}
          >
            <CheckBox />
            OUI
          </Button>
          <Button
            color="secondary"
            variant="contained"
            style={{ marginBottom: "1px" }}
            onClick={() => setOpenDelete(!openDelete)}
          >
            <CancelPresentationSharp />
            Non
          </Button>
        </FlexBetween>
      </PopupConfirm>
    </Box>
  );
};

export default Products;
